export default __webpack_public_path__ + "media/design-system/icon/assets/brand/LG/check-6a37340b33456e202c04fab03ce67bb8.svg";